import Vue from 'vue'
import Router from 'vue-router'
import Entry from './views/Entry.vue'
import { getCurrentPrefix } from '@/utils/tools'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: getCurrentPrefix(),
  routes: [
    {
      path: '/p/:fileId',
      name: 'pEntry',
      component: Entry
    }, {
      path: '/l/:sid',
      name: 'lEntry',
      component: Entry
    }
  ]
})
